const defaultTrailerIconSize = 60;

export default defaultTrailerIconSize;
